export const checkFileSize = function(file, _this, maxsize, errormsg) {
    let newmaxsize = maxsize ? maxsize : 10;
    let newerrormsg = errormsg ? errormsg : "图片大小不能超过10M";
    const isJPG = file.type === "image/jpg";
    const isPNG = file.type === "image/png";
    const isJEPG = file.type === "image/jpeg";
    const sizeAvailable = file.size / 1024 / 1024 < newmaxsize;
    if (!isJPG && !isPNG && !isJEPG) {
        _this.$message.error("上传图片只能是 JPG/PNG/JPEG 格式!");
        return false;
    }
    if (!sizeAvailable) {
        _this.$message({
            message: newerrormsg,
            type: "warning"
        });
        return false;
    }
    return true;
};
